import { createTRPCReact } from '@trpc/react-query';
import { httpBatchLink } from '@trpc/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import superjson from 'superjson';
import type { AppRouter } from '../../api/router';
import type { ReactNode } from 'react';

export const trpc = createTRPCReact<AppRouter>();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1 },
    mutations: { retry: 0 },
  },
});

const trpcClient = trpc.createClient({
  links: [
    httpBatchLink({
      url: '/api/trpc',
      transformer: superjson,
      headers() {
        const initData =
          typeof window !== 'undefined'
            ? window.Telegram?.WebApp?.initData
            : '';
        return initData ? { 'X-Telegram-Init-Data': initData } : {};
      },
      fetch(input, init) {
        // 'same-origin' is the right setting:
        //   - Mini App: API and Mini App share the origin, cookies (if any)
        //     are sent, but auth is via the X-Telegram-Init-Data header anyway.
        //   - Web (browser): the `bc_session` cookie (set after Telegram Login
        //     Widget) and `bc_admin` cookie are sent, enabling account.* and
        //     admin.* procedures. 'omit' would break both.
        return globalThis.fetch(input, {
          ...(init ?? {}),
          credentials: 'same-origin',
        });
      },
    }),
  ],
});

export function TRPCProvider({ children }: { children: ReactNode }) {
  return (
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>
        {children}
      </QueryClientProvider>
    </trpc.Provider>
  );
}
